import React, { Component } from "react"
import axios from 'axios';
import Loading from './../components/loading'
import Sidebar from '../components/sidebar'
import { Fade } from 'react-reveal';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Table from 'react-bootstrap/Table'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import NumberFormat from 'react-number-format';

class calculationResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            calculate: [],
            withCalculation: true
        };
    }

    componentDidMount() {
        let apihost
        switch (window.location.hostname) {
            case "localhost":
                apihost = "https://krmslcms.emlakkatilim.com.tr";
                break;
            case "mortgagetest.emlakkatilim.com.tr":
                apihost = "https://krmslcms.emlakkatilim.com.tr";
                break;
            case "www.emlakkatilim.com.tr":
                apihost = "https://www.emlakkatilim.com.tr";
                break;
            default:
                apihost = "https://www.emlakkatilim.com.tr";
                break;
        }
        const search = this.props.location.search;
        const FundingAmount = new URLSearchParams(search).get('FundingAmount');
        const InstallmentCount = new URLSearchParams(search).get('InstallmentCount');
        const ProfitRate = new URLSearchParams(search).get('ProfitRate');
        if (FundingAmount !== null) {

            axios.get(apihost + "/Plugins/CalculateLoansProduct", {
                params: {
                    CalculationTypeId: 1,
                    ProductTypeId: "GMENKULKONUTYENI",
                    Cost: 0,
                    InstalmentAmountDisplay: 0,
                    InstalmentAmount: 0,
                    LoanAmount: FundingAmount,
                    LoanMaturity: InstallmentCount,
                    CustomRate: ProfitRate,
                    LoanSegmentId: 2
                }
            })
                .then(res => this.setState({
                    calculate: res.data,
                    isLoaded: true,
                    withCalculation: false
                }))
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    //
                })
        } else {
            this.setState({
                isLoaded: true
            })
        }
    }
    render() {
        const { error, isLoaded } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <Loading />;
        } else {
            return (
                <>
                    <Jumbotron className="subpageHeader" fluid>
                        <Fade>
                            <Container>
                                <h1>Finansman Hesaplama</h1>
                                <Breadcrumb>
                                    <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Finansman Hesaplama</Breadcrumb.Item>
                                </Breadcrumb>
                            </Container>
                        </Fade>
                    </Jumbotron>
                    <section>
                        <Container>
                            <Row>
                                <Col className="subpageContent" sm={9}>
                                    {
                                        this.state.withCalculation === false ?
                                            <>
                                                <Fade bottom><h2>Finansman Hesaplama</h2></Fade>
                                                <div class="table-responsive">
                                                    <Fade bottom>
                                                        <Table className="text-center mb-5" bordered hover size="md">
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th>FİNANSMAN TUTARI</th>
                                                                    <th>VADE</th>
                                                                    <th>KAR ORANI</th>
                                                                    <th>AYLIK TAKSİT TUTARI</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.calculate.Data.FundingAmount} displayType={'text'} suffix={' ₺'} /></td>
                                                                    <td>{this.state.calculate.Data.InstallmentCount}</td>
                                                                    <td>{this.state.calculate.Data.ProfitRate}</td>
                                                                    <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.calculate.Data.InstallmentContractList[0].Amount} displayType={'text'} suffix={' ₺'} /></td>
                                                                </tr>
                                                            </tbody>
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th>TOPLAM GERİ ÖDEME</th>
                                                                    <th>TOPLAM MASRAFLAR</th>
                                                                    <th>İPOTEK TESİS BEDELİ</th>
                                                                    <th>EKSPERTİZ ÜCRETİ</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.calculate.Data.TotalInstallmentAmount} displayType={'text'} suffix={' ₺'} /></td>
                                                                    <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.calculate.Data.TotalExpense} displayType={'text'} suffix={' ₺'} /></td>
                                                                    <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.calculate.Data.HypothecAmount} displayType={'text'} suffix={' ₺'} /></td>
                                                                    <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={this.state.calculate.Data.ExpertiseAmount} displayType={'text'} suffix={' ₺'} /></td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </Fade>
                                                </div>
                                                <div class="table-responsive">
                                                    <Fade bottom>
                                                        <Table className="text-center mb-5" bordered hover size="md">
                                                            <thead className="thead-dark">
                                                                <tr>
                                                                    <th colSpan="5">ÖDEME TABLOSU</th>
                                                                </tr>
                                                            </thead>
                                                            <thead className="thead-light">
                                                                <tr>
                                                                    <th>VADE</th>
                                                                    <th>Aylık Taksit Tutarı</th>
                                                                    <th>Anapara Taksit Tutarı</th>
                                                                    <th>Anapara Taksit Tutarı</th>
                                                                    <th>Kalan Anapara Tutarı</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.state.calculate.Data.InstallmentContractList.map((intalment, i) => (
                                                                    <tr key={i}>
                                                                        <td>{intalment.OrderNumber}</td>
                                                                        <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={intalment.Amount} displayType={'text'} suffix={' ₺'} /></td>
                                                                        <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={intalment.PrincipalAmount} displayType={'text'} suffix={' ₺'} /></td>
                                                                        <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={intalment.ProfitAmount} displayType={'text'} suffix={' ₺'} /></td>
                                                                        <td><NumberFormat thousandSeparator={'.'} decimalSeparator={','} value={intalment.RemainingPrincipalAmount} displayType={'text'} suffix={' ₺'} /></td>
                                                                    </tr>
                                                                ))}

                                                            </tbody>
                                                        </Table>
                                                    </Fade>
                                                </div>
                                                <blockquote className="blockquote">
                                                    <footer className="blockquote-footer">Ekspertiz ücreti tahmini olarak hesaplanmıştır. Bu ücrete belediye harcı ve yol ücreti dahil değildir.</footer>
                                                    <footer className="blockquote-footer">Tahsis ücreti müşteriden peşin olarak tahsil edilecektir. Ödenecek toplam tutar masrafları içermemektedir. Bu tablo bilgi amaçlıdır. Türkiye Emlak Katılım Bankası A.Ş’ ni hiçbir şekilde taahhüt altına sokmaz.</footer>
                                                    <footer className="blockquote-footer">Kredili Hayat ve BES ürünlerinin bankamızdan kullanılması halinde 5 puan indirim geçerli olacaktır.</footer>
                                                    <footer className="blockquote-footer">Kar oranı 300,000 TL’ ye kadar geçerlidir. 300,000 TL üstü finansmanlar için şubelerimiz ile iletişime geçebilirsiniz.</footer>
                                                </blockquote>
                                            </>
                                            : null
                                    }
                                </Col>
                                <Col sm={3}>
                                    <Sidebar />
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </>
            );
        }
    }
}

export default calculationResult;